import feesAndChargesJson from './content/fees-and-charges.json';

export const feesAndChargesMock = {
    layoutType: 2,
    data: {
        name: 'fees-and-charges',
        areasList: [
            {
                id: 1,
                name: 'FeesAndChargesPage',
                componentName: 'Comp:FeesAndChargesPage',
                content: JSON.stringify(feesAndChargesJson)
            }
        ]
    }
};
